import { useRef, useEffect } from 'react';

/** @deprecated - use from @make-software/cspr-design */
export function useClickAndTouchAway({ callback }) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const listener = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback(event);
      }
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, callback]);

  return { ref };
}
